import {Component, Input} from "@angular/core";
import {FormFieldConfig, translateFormValue} from "./form-field-config";

@Component({
  selector: "app-form-field-display",
  templateUrl: "./form-field-display.component.html",
  standalone: false
})
export class FormFieldDisplayComponent {
  @Input() formFieldConfig: FormFieldConfig<any> | undefined;

  @Input() label = "";
  @Input() value? = "";
  @Input() displayHorizontal = true;
  @Input() infoText: string | undefined;

  getLocalizedFormValue(): string | undefined {
    return (
      this.value ||
      translateFormValue(this.formFieldConfig!, this.formFieldConfig!.model[this.formFieldConfig!.property], (key) => key)
    );
  }

  getTestId() {
    return this.formFieldConfig === undefined
      ? ""
      : this.formFieldConfig.property.toString() + "-display";
  }
}
